import { useMutation, useQueryClient } from '@tanstack/react-query';

import { revokeMcpOAuthGrant } from '@/api/v4/mcp-oauth.api';
import { QueryKey } from '@/config/query-client';

export const useRevokeMcpOAuthGrant = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      await revokeMcpOAuthGrant(id);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKey.McpOAuthGrants],
      });
    },
  });

  return {
    revokeGrant: mutation.mutateAsync,
    isRevoking: mutation.isPending,
  };
};
